import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { ChevronDownIcon, ChevronUpIcon } from '@dynatrace/strato-icons';

import { Button } from '../../../../../buttons/button/Button.js';
import { Flex } from '../../../../../layouts/flex/Flex.js';
import { FLAME_ISOLATION_NAV_MESSAGES } from './messages.js';

interface FlameIsolationNavProps {
  canGoBack: boolean;
  canGoForward: boolean;
  onGoBack: () => void;
  onGoForward: () => void;
}

/**
 * @internal
 */
export function FlameIsolationNav({
  canGoBack,
  canGoForward,
  onGoBack,
  onGoForward,
}: Readonly<FlameIsolationNavProps>): ReactNode {
  const intl = useIntl();
  return (
    <Flex gap={4} alignItems="center">
      <Button
        variant="default"
        size="condensed"
        disabled={!canGoBack}
        onClick={onGoBack}
        aria-label={intl.formatMessage(FLAME_ISOLATION_NAV_MESSAGES.goBack)}
      >
        <Button.Prefix>
          <ChevronUpIcon />
        </Button.Prefix>
      </Button>
      <Button
        variant="default"
        size="condensed"
        disabled={!canGoForward}
        onClick={onGoForward}
        aria-label={intl.formatMessage(FLAME_ISOLATION_NAV_MESSAGES.goForward)}
      >
        <Button.Prefix>
          <ChevronDownIcon />
        </Button.Prefix>
      </Button>
    </Flex>
  );
}
